import { render, staticRenderFns } from "./transactionSetup.vue?vue&type=template&id=31962c5e&scoped=true&"
import script from "./transactionSetup.vue?vue&type=script&lang=js&"
export * from "./transactionSetup.vue?vue&type=script&lang=js&"
import style0 from "./transactionSetup.vue?vue&type=style&index=0&id=31962c5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31962c5e",
  null
  
)

export default component.exports